import React from "react";
import CodeMirror from "@uiw/react-codemirror";
import { html } from "@codemirror/lang-html";
import DOMPurify from "dompurify";

export default function HtmlEditorWithPreview(props) {
  const { setHtmlCode, htmlCode, description } = props;

  return (
    <div style={{ marginBottom: "30px" }}>
      <label>{description}</label>

      <div
        style={{
          display: "flex",
         
        }}
      >
        {/* HTML Editor - Left */}
        <div style={{ flex: 1 }}>
          <h3>HTML Editor</h3>

          <CodeMirror
            value={htmlCode}
            height="650px"
            width="600px"
            extensions={[html()]}
            theme="dark"
            onChange={(value) => setHtmlCode(value)}
          />
        </div>

        {/* Preview - Right */}
       <div style={{ flex: 1 }}>
  <h3>Live Preview</h3>

  <div
    style={{
      width: "600px",
      height: "650px",
      border: "1px solid #7d7373",
      borderRadius: "4px",
      overflow: "auto",
      color: "#0a0a0a",
      padding: "16px",
      boxSizing: "border-box",
    }}
  >
    <div
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(htmlCode),
      }}
    />
  </div>
</div>
      </div>
    </div>
  );
}